import { getLocalTimeZone, now } from "@internationalized/date"
import { Link } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import Logo from "@/assets/logos/inflow/inflow-royal.svg"
import Separator from "@/globalComponents/atoms/Separator"
import Text from "@/globalComponents/atoms/Text"
import { useScopedTo } from "@/utilities/hooks/useScopedRouting"

function Footer() {
  const { t } = useTranslation()
  const scoped = useScopedTo()

  return (
    <footer>
      <div className="footer-logo">
        <Logo />
      </div>
      <div className="footer-links">
        <Link
          {...scoped({ to: "/privacy-policy" })}
          className="body--3"
          preload={false}
        >
          {t("navigation.footer.privacyPolicy")}
        </Link>
        <Separator orientation="vertical" />
        <Link
          {...scoped({ to: "/terms-of-use" })}
          className="body--3"
          preload={false}
        >
          {t("navigation.footer.termsOfUser")}
        </Link>
      </div>
      <div>
        <Text level={3} className="center">
          {t("navigation.footer.copyright", {
            currentYear: now(getLocalTimeZone()).year,
          })}
        </Text>
      </div>
    </footer>
  )
}

export default Footer
